import { motion } from "framer-motion";
import SectionHeading from "@/components/SectionHeading";
import { CHAPTERS } from "@/lib/site-data";

const ease = [0.22, 1, 0.36, 1];

export default function Manifesto() {
  return (
    <section id="savoir-faire" data-testid="manifesto-section" className="relative border-t border-white/5 bg-[#0A0C0F] py-28 md:py-36">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-[1fr_1.4fr]">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <SectionHeading
            eyebrow="Savoir-faire"
            title="Quatre gestes, une toiture qui dure"
            copy="Notre méthode n’a pas changé depuis 1999 : observer, choisir, poser, finir. C’est ce qui fait la différence entre une couverture et une œuvre."
          />
        </div>
        <div>
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              data-testid={`manifesto-chapter-${c.num}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.7, ease }}
              className="group border-t border-white/10 py-10 last:border-b"
            >
              <div className="flex items-start gap-6 md:gap-10">
                <span className="text-outline shrink-0 font-serif text-6xl leading-none transition-all duration-500 group-hover:[-webkit-text-stroke-color:rgba(217,107,67,0.7)] md:text-7xl">
                  {c.num}
                </span>
                <div>
                  <h3 className="font-serif text-2xl text-slate-100">{c.title}</h3>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-400">{c.text}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
